<template>
  <div class="wxExternalContact wv100 hv100">
    <!-- 标签 -->
    <div class="labelDiv">
      <div class="labelDivSe">
        <van-search
          v-model="keyWord"
          @search="keyWSearch"
          @cancel="keyWCancel"
          @input="keyWInput"
          placeholder="请输入搜索关键词"
        />
      </div>
      <div class="labelDivDe">
        <van-dropdown-menu active-color="#1989fa" v-if="!multiLabel">
          <van-dropdown-item
            v-model="lableValue"
            :options="lableList"
            @change="lableChange"
          />
        </van-dropdown-menu>
        <van-dropdown-menu v-if="multiLabel">
          <van-dropdown-item
            :title="lableListResultTitle"
            active-color="#1989fa"
            ref="dropdownItem"
            @open="dropdownItemOpen"
            @close="dropdownItemClose"
          >
            <div>
              <van-cell @click="toggleTagAll">
                <template #title>
                  <span class="custom-title">全部标签</span>
                </template>
                <template #right-icon>
                  <van-checkbox v-model="selectAllTag" ref="toggleTagAll">
                  </van-checkbox>
                </template>
              </van-cell>
            </div>
            <van-checkbox-group v-model="lableListResult">
              <van-cell-group>
                <van-cell
                  v-for="(item, index) in lableList"
                  clickable
                  :key="index"
                  @click="toggleTag(index)"
                >
                  <template #title>
                    <span class="custom-title">{{ item.text }}</span>
                  </template>
                  <template #right-icon>
                    <van-checkbox :name="item.value" ref="checkboxesTag">
                      <template #icon="props">
                        <van-icon
                          v-if="props.checked"
                          name="success"
                          color="##1989fa"
                        />
                      </template>
                    </van-checkbox>
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
            <div style="padding: 5px 16px;">
              <van-button type="info" block round @click="onConfirm">
                确 认
              </van-button>
            </div>
          </van-dropdown-item>
        </van-dropdown-menu>
      </div>
    </div>
    <van-divider />
    <!-- 全选 -->
    <div class="h44 bg-ff selectAllDiv">
      <van-checkbox v-model="seleclAll" @click="seleclAllChange"
        >全部选择</van-checkbox
      >
      <div
        v-if="upDateUserUrl.length > 0"
        class="upDateUser"
        @click="upDateUser"
      >
        更新客户
      </div>
    </div>
    <van-divider />
    <van-checkbox-group class="" v-model="selectResult">
      <van-cell-group class="listBarB">
        <listScroll
          :listData="userList"
          :loadEnd="loadEnd"
          :loadEndText="loadEndText"
          @loadNext="getwxExuser"
          ref="listScrollCP"
        >
          <template v-slot:itemRow="itemData">
            <div class="indexAnchor" v-if="itemData.item.first_py_show">
              {{ itemData.item.first_py }}
            </div>
            <div v-else>
              <van-divider />
            </div>
            <van-cell @click="toggle('checkboxes' + itemData.item.index)">
              <!-- <van-cell> -->
              <template #title>
                <div class="exUserItem">
                  <div class="exUserItemAc">
                    <van-checkbox
                      :name="itemData.item.id"
                      :ref="'checkboxes' + itemData.item.index"
                      @change="itemChange"
                    >
                    </van-checkbox>
                  </div>
                  <div class="exUserItemIm">
                    <van-image
                      width="40"
                      height="40"
                      fit="cover"
                      :src="itemData.item.avatar"
                    />
                  </div>
                  <div class="exUserItemTx">
                    <p v-if="Number(itemData.item.type) == 1" class="name">
                      <template v-if="itemData.item.remark.length > 0">
                        {{ itemData.item.remark }}
                      </template>
                      <template v-else>
                        {{ itemData.item.name }}
                      </template>
                      <span class="wxTx">@微信</span>
                    </p>
                    <p v-else class="name">
                      <template v-if="itemData.item.remark.length > 0">
                        {{ itemData.item.remark }}
                      </template>
                      <template v-else>
                        {{ itemData.item.name }}
                      </template>
                      <span class="qyWxTx">@{{ itemData.item.corp_name }}</span>
                    </p>
                    <p class="label">
                      <van-tag
                        v-for="(l, li) in itemData.item.tags"
                        :key="li"
                        plain
                        type="primary"
                        >{{ l.tag_name }}</van-tag
                      >
                    </p>
                  </div>
                </div>
              </template>
            </van-cell>
          </template>
        </listScroll>
      </van-cell-group>
    </van-checkbox-group>
    <!-- 结果 -->
    <div class="resultDiv">
      <van-divider />
      <div class="resultDivImAc">
        <div class="resultDivIm">
          <van-image
            v-for="(item, index) in selectUser"
            :key="index"
            width="40px"
            height="40px"
            fit="cover"
            :src="item.avatar"
          />
        </div>
        <div class="resultDivAc">
          <van-button type="info" size="small" @click="wxExcomfireSelect">
            <template v-if="selectUser.length > 0">
              确定({{ selectUser.length }})
            </template>
            <template v-else>返回</template>
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import listScroll from "../listScroll";
export default {
  props: {
    initUser: Array,
    getDataUrl: String,
    labelUrl: String,
    upDateUserUrl: {
      type: String,
      default: ""
    },
    multiLabel: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      indexList: [],
      userList: [],
      selectUser: [],
      lableValue: "",
      // lableList: [{ text: "全部标签", value: "" }],
      lableList: [],
      seleclAll: false,
      sticky: false,
      keyWord: "",
      selectResult: [],
      loadEnd: false,
      page: 1,
      page_size: 200,
      loading: false,
      loadEndText: "",
      lableListResult: [],
      lableListResultTitle: "全部标签",
      selectAllTag: false,
      isLableListResultChange: false,
      lastParameter: {
        closeUnSet: false,
        lableListResult: [],
        lableListResultTitle: ""
      }
    };
  },
  watch: {
    selectResult() {
      this.changeSelectAllType();
      this.setSelectUser();
    },
    selectAllTag(n) {
      if (n) {
        this.lableListResult = [];
        this.lableList.forEach(item => {
          this.lableListResult.push(item.value);
        });
      } else {
        if (!this.isLableListResultChange) {
          this.lableListResult = [];
        }
      }
    },
    lableListResult(n) {
      if (n.length == this.lableList.length) {
        this.selectAllTag = true;
      } else {
        this.selectAllTag = false;
      }
    }
  },
  components: {
    listScroll
  },
  async mounted() {},
  methods: {
    toggleTag(index) {
      this.isLableListResultChange = true;
      this.$refs.checkboxesTag[index].toggle();
    },
    keyWCancel() {
      this.keyWord = "";
      this.page = 1;
      this.getwxExuser();
    },
    keyWSearch(key) {
      this.keyWord = key;
      this.page = 1;
      this.getwxExuser();
    },
    keyWInput(key) {
      if (key.trim().length === 0) {
        this.keyWord = "";
        this.page = 1;
        this.getwxExuser();
      }
    },
    lableChange() {
      this.page = 1;
      this.getwxExuser();
    },
    // 获取外部联系人
    async getwxExuser() {
      if (this.loading === true) {
        return;
      }
      this.loading = true;
      let resData = await this.$common.http({
        url: this.getDataUrl,
        data: {
          data: JSON.stringify({
            page: this.page,
            page_size: this.page_size,
            tag_wxids: this.lableListResult,
            tag_wxid: this.lableValue,
            keyword: this.keyWord
          })
        }
      });
      let userList = resData.data.data;
      if (this.page === 1) {
        this.loadEnd = false;
        this.userList = userList;
      } else {
        userList.forEach(i => {
          this.userList.push(i);
        });
      }
      let indexList = [];
      let indexListUserId = [];
      this.userList.forEach((i, index) => {
        indexList.push(i.first_py);
        indexListUserId.push(i.id);
        i.index = index.toString();
        if (
          !this.userList[Number(index - 1)] ||
          i.first_py != this.userList[Number(index) - 1].first_py
        ) {
          i.first_py_show = true;
        } else {
          i.first_py_show = false;
        }
      });
      // 第一次调用
      if (this.page == 1) {
        // 由于是一次性加载数据，缓存一次，用于统计选择人员
        // this.userListAll = JSON.parse(JSON.stringify(this.userList));
        // 索引数组
        this.indexList = Array.from(new Set(indexList));
        // 选中数据数据
        // this.setSelectUser();
        // 回调调组件
        // this.$emit("wxExcomfireSelect", this.selectUser);
      }
      // 过滤已选择数据中不包含在当前返回的数据
      let selectResult = [];
      this.selectResult.forEach(i => {
        if (indexListUserId.indexOf(i) >= 0) {
          selectResult.push(i);
        }
      });
      this.selectResult = selectResult;
      // 全选按钮控制
      this.changeSelectAllType();
      this.loading = false;
      this.page += 1;
      if (resData.data.data.length < this.page_size) {
        this.loadEnd = true;
        this.loadEndText =
          "共" + this.userList.length + "条数据，没有更多内容啦~";
      }
    },
    setSelectUser() {
      this.selectUser = [];
      this.userList.forEach(i => {
        if (this.selectResult.indexOf(i.id.toString()) >= 0) {
          this.selectUser.push(i);
        }
      });
    },
    // 获取标签数据接口
    getLebalData() {
      this.$common
        .http({
          url: this.labelUrl,
          data: {},
          noLoading: true
        })
        .then(res => {
          console.log("getLebalData", res);
          let lableGroup = res.data.data;
          if (!this.multiLabel) {
            this.lableList.push({ text: "全部标签", value: "" });
          }
          lableGroup.forEach(item => {
            let tags = item.tags;
            let name = item.group_name;
            tags.forEach(itemT => {
              let text = itemT.name + " [" + name + "]";
              let value = itemT.wxid;
              this.lableList.push({ text: text, value: value });
              // this.lableListResult.push(value);
            });
          });
        });
    },
    // 确认选择
    wxExcomfireSelect() {
      this.$emit("wxExcomfireSelect", this.selectUser);
    },
    // 全选改变
    seleclAllChange() {
      this.selectResult = [];
      if (this.seleclAll) {
        this.userList.forEach(i => {
          this.selectResult.push(i.id);
        });
      }
    },
    // 其他值改变时，全选状态变动
    changeSelectAllType() {
      let count = 0;
      this.userList.forEach(i => {
        if (this.selectResult.indexOf(i.id.toString()) >= 0) {
          count++;
        }
      });
      if (count === this.userList.length && this.userList.length != 0) {
        this.seleclAll = true;
      } else {
        this.seleclAll = false;
      }
    },
    itemChange(type, id) {
      console.log(type, id);
    },
    toggle(index) {
      this.$refs[index].toggle();
    },
    listScrollRe() {
      this.$refs.listScrollCP.pRefresh();
    },
    // 获取初始化数据
    getInitData() {
      this.$common
        .http({
          url: this.getDataUrl,
          data: {
            data: JSON.stringify({
              page: 1,
              page_size: this.initUser.length,
              tag_wxid: "",
              keyword: "",
              ex_userids: this.initUser
            })
          }
        })
        .then(res => {
          console.log(res);
        });
    },
    toggleTagAll() {
      this.isLableListResultChange = false;
      this.$refs["toggleTagAll"].toggle();
    },
    onConfirm() {
      if (this.lableListResult.length == this.lableList.length) {
        this.lableListResultTitle = "全部标签";
      } else {
        let lableListResultTitleArr = [];
        this.lableListResult.forEach(item => {
          for (let i in this.lableList) {
            let itemO = this.lableList[i];
            if (itemO.value == item) {
              lableListResultTitleArr.push(itemO.text);
              break;
            }
          }
        });
        this.lableListResultTitle =
          lableListResultTitleArr.length > 0
            ? lableListResultTitleArr.join(",")
            : "无选中标签";
      }
      this.page = 1;
      this.getwxExuser();
      this.lastParameter.closeUnSet = true;
      this.$refs.dropdownItem.toggle();
    },
    dropdownItemOpen() {
      this.lastParameter = {
        closeUnSet: false,
        lableListResult: this.lableListResult,
        lableListResultTitle: this.lableListResultTitle
      };
    },
    dropdownItemClose() {
      if (!this.lastParameter.closeUnSet) {
        this.isLableListResultChange = true;
        this.lableListResult = this.lastParameter.lableListResult;
        this.lableListResultTitle = this.lastParameter.lableListResultTitle;
      }
    },
    upDateUser() {
      this.$common
        .http({
          url: this.upDateUserUrl,
          data: {}
        })
        .then(res => {
          if (Number(res.data.errcode) == 0) {
            this.$common.mbToastSuccess(res.data.message);
          }
        });
    }
  },
  created() {
    console.log(this);
    this.selectResult = this.initUser;
    this.getLebalData();
    this.getwxExuser();
    if (this.selectResult.length > 0) {
      this.getInitData();
    }
  }
};
</script>
<style lang="less">
.wxExternalContact {
  position: absolute;
  left: 0;
  top: 0;
  background-color: #f4f4f4;
  overflow: hidden;
  .h44 {
    height: 44px;
  }
  .bg-ff {
    background-color: #ffffff;
  }
  .van-divider {
    margin: 0;
  }
  .labelDiv {
    display: flex;
    padding-right: 10px;
    background-color: #ffffff;
    .labelDivSe {
      width: calc(100vw - 95px);
    }
    .labelDivDe {
      width: 95px;
      box-sizing: border-box;
      .van-ellipsis {
        width: 60px;
        font-size: 14px;
      }
    }
  }
  .selectAllDiv {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 16px;
    .upDateUser {
      padding-right: 16px;
      color: #1989fa;
    }
  }
  .van-dropdown-menu__bar {
    height: 54px;
    box-shadow: none;
  }
  .van-dropdown-menu__item {
    justify-content: center;
  }
  .van-dropdown-menu__title {
    padding-left: 0;
  }
  .van-index-anchor {
    text-align: left;
    background: #f4f4f4;
  }
  .listBarB {
    height: calc(100vh - 100px);
    overflow: hidden;
    padding-bottom: 70px;
    box-sizing: border-box;
  }
  .listBar {
    height: calc(100vh - 120px);
    overflow: auto;
    padding-bottom: 70px;
    box-sizing: border-box;
    background: #f4f4f4;
  }
  .exUserItem {
    display: flex;
    align-items: center;
    line-height: normal;
    .exUserItemAc {
    }
    .exUserItemIm {
      margin-left: 10px;
    }
    .exUserItemTx {
      width: calc(100vw - 110px);
      margin-left: 10px;
      p {
        margin: 0;
        padding-bottom: 2px;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .name {
        text-align: left;
        line-height: 14px;
      }
      .label {
        .van-tag {
          margin-right: 2px;
        }
      }
    }
  }
  .resultDiv {
    position: fixed;
    width: 100vw;
    bottom: -1px;
    left: 0;
    height: 64px;
    background-color: #ffffff;
    box-sizing: border-box;
    .resultDivImAc {
      display: flex;
      align-items: center;
      padding: 11px 16px 0px 16px;
      padding-top: 11px;
    }
    .resultDivIm {
      width: calc(100vw - 120px);
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      text-align: left;
      height: 44px;
      .van-image {
        margin-right: 3px;
        display: inline-block;
      }
    }
    .resultDivAc {
      width: 120px;
      padding-left: 16px;
      .van-button--small {
        font-size: 14px !important;
        width: 95px;
      }
    }
  }
  .emptyData {
    color: #a4a4a4;
  }
  .van-index-bar__index--active {
    color: #1989fa;
  }
  .wxTx {
    font-size: 12px;
    color: #07c160;
    padding-left: 2px;
  }
  .qyWxTx {
    font-size: 12px;
    color: #ee0a24;
    padding-left: 2px;
  }
  .indexAnchor {
    line-height: 20px;
    font-size: 14px;
    padding-left: 16px;
    display: inline-block;
    width: 100%;
    text-align: left;
    background: #f4f4f4;
  }
  .van-cell__title {
    text-align: left;
  }
  .van-dropdown-menu__title--active {
    color: #1989fa !important;
  }
}
</style>
